import React from "react";
import { PropertyList } from "../../../components/PropertyList";

const PropertyListPage: React.FC = () => {
  return <PropertyList />;
};

export default PropertyListPage;
